import {EventsState} from "../types/EventsState";
import { ExhibitionsListHelper } from "@service/store/events/exhibitions/ExhibitionsListHelper";
import { repositories } from "@service/api/Repositories";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";

export const state: EventsState = {
    list: [],
    isLoaded: false,
    selected: null,
    exhibitions: new ExhibitionsListHelper(repositories.get(RepositoryFabric.OBJECT))
}
